<div class="content">
  <div class="selectors-box flex column">
    <div class="filter-chips-container">
      <app-email-filter
        [(value)]="selectedEmail"
        (valueChange)="setUsers$.next()"
      ></app-email-filter>
      <app-name-filter
        [(value)]="selectedUserName"
        (valueChange)="setUsers$.next()"
      ></app-name-filter>
      <app-role-filter
        [(value)]="selectedRole"
        (valueChange)="setUsers$.next()"
      ></app-role-filter>
      <app-client-filter
        [(value)]="selectedClient"
        (valueChange)="setUsers$.next()"
      ></app-client-filter>

      @if (hasActiveFilters) {
        <button
          class="clear-all-filters-btn"
          (click)="clearAllFilters()"
        >
          Szűrők törlése
        </button>
      }
    </div>

    <div class="selector-row flex vcenter">
      <button
        payee-button
        (click)="createUser()"
      >
        Új felhasználó
      </button>
      @if (tableLoading) {
        <mat-progress-spinner
          color="accent"
          diameter="24"
          class="table-loading-spinner"
          mode="indeterminate"
        ></mat-progress-spinner>
      }
    </div>
  </div>

  <div class="table-scroll">
    <table
      mat-table
      custom-table
      multiTemplateDataRows
      matSort
      class="mat-elevation-z1 users-table"
      [dataSource]="dataSource"
      (matSortChange)="sortData($event)"
    >
      <ng-container matColumnDef="created_at">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Létrehozva
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.created_at | date: "yyyy.MM.dd HH:mm" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Felhasználó email címe
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="user_name">
        <th
          *matHeaderCellDef
          mat-header-cell
          mat-sort-header
        >
          Felhasználó neve
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          {{ element.user_name }}
        </td>
      </ng-container>

      <ng-container matColumnDef="role_name">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Jogosultságok
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          @for (role of element.roles; track role) {
            <li>
              {{ role.name }}
            </li>
          }
          @if (element.roles.length === 0) {
            <div>Nincs hozzárendelve jogosultság</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="clients">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Hitelezők
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          @if (element.clients.length > 0) {
            <div class="flex vcenter">
              <span>{{ element.clients[0].name }}</span>
              @if (element.clients.length > 1) {
                <span>&nbsp;+ {{ element.clients.length - 1 }}</span>
              }
            </div>
          }
          @if (element.clients.length === 0) {
            <div>Nincs hozzárendelve hitelező</div>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="digest_notifications">
        <th
          *matHeaderCellDef
          mat-header-cell
        >
          Digest Értesítések
        </th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <mat-checkbox
            [checked]="element.digest_notifications"
            (change)="toggleDigestNotifications(element, $event)"
          >
            <button
              payee-button
              width="shorter"
              height="short"
              [disabled]="!element.digest_notifications_exists"
              (click)="sendDigestNotifications(element)"
            >
              Küldés
            </button>
          </mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="edit_roles">
        <th
          *matHeaderCellDef
          mat-header-cell
        ></th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <button
            payee-button
            width="shorter"
            height="short"
            (click)="editUser(element)"
          >
            Szerkesztés
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="delete">
        <th
          *matHeaderCellDef
          mat-header-cell
        ></th>
        <td
          *matCellDef="let element"
          mat-cell
        >
          <button
            payee-button
            width="shorter"
            height="short"
            (click)="deleteUser(element)"
          >
            Törlés
          </button>
        </td>
      </ng-container>

      <tr
        *matHeaderRowDef="displayedColumns"
        mat-header-row
      ></tr>
      <tr
        *matRowDef="let element; columns: displayedColumns"
        mat-row
        class="element-row"
      ></tr>
    </table>
  </div>

  <mat-paginator
    disableUnderline
    class="mat-elevation-z1"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [pageSizeOptions]="[1, 5, 10, 25, 100]"
    [length]="length"
    (page)="pageChange($event)"
  ></mat-paginator>
</div>
